<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
  >
    <path d="M6 0.5C9.31371 0.5 12 3.18629 12 6.5C12 9.81371 9.31371 12.5 6 12.5C2.68629 12.5 0 9.81371 0 6.5C0 3.18629 2.68629 0.5 6 0.5ZM6 1.5C3.23858 1.5 1 3.73858 1 6.5C1 9.26142 3.23858 11.5 6 11.5C8.76142 11.5 11 9.26142 11 6.5C11 3.73858 8.76142 1.5 6 1.5ZM6 8.5C6.41421 8.5 6.75 8.83579 6.75 9.25C6.75 9.66421 6.41421 10 6 10C5.58579 10 5.25 9.66421 5.25 9.25C5.25 8.83579 5.58579 8.5 6 8.5ZM6 3C6.24546 3 6.44961 3.17688 6.49194 3.41012L6.5 3.5V7C6.5 7.27614 6.27614 7.5 6 7.5C5.75454 7.5 5.55039 7.32312 5.50806 7.08988L5.5 7V3.5C5.5 3.22386 5.72386 3 6 3Z" />
  </svg>
</template>
